// Library import
import axios from 'axios';

// File Import
import {apiEndPoints} from './apiEndPoints';

export class AuthApi {
    static logout() {
        return axios.get(apiEndPoints.AUTH.LOGOUT_GET);
    }
}
